/* 🤖 this file was generated by svg-to-ts */
export const matIconGifBox: {
  name: 'gif-box';
  data: string;
} = {
  name: 'gif-box',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M19 19H5V5h14v14zM5 3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5zm6.5 11h1v-4h-1v4zm2 0h1v-1.5H16v-1h-1.5V11h2v-1h-3v4zm-4-2v1h-1v-2h2c0-.55-.45-1-1-1h-1c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h-1z"/></svg>`
};
